import { useIonLoading } from '@ionic/react'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useStepsContext } from '../../context/StepsContext'
import useMessages from '../../hooks/useMessages'
import useRequests from '../../hooks/useRequests'
import Button from '../Button'

interface Props {
  storeForm: string
  landing?: boolean
}

const LineButton = ({ storeForm, landing }: Props) => {
  const formData = useSelector((state: any) => state[storeForm])
  const [validity, setValidity] = useState(true)
  const { newProcedureStep, setNewProcedureStep }: any = useStepsContext()
  const { chipAndLineValidations, savePortabilityDocuments } = useRequests(storeForm)
  const otherNoFilledValues = Object.values({ ...formData })
    .slice(0, 3)
    .some((value) => !value)
  const values = Object.values({ ...formData })
  const { emailOptional, ...lineForm } = formData
  const { toastMessage } = useMessages()
  const [present, dismiss] = useIonLoading()

  useEffect(() => {
    if (storeForm === 'lineValidationPYForm') {
      if (Object.values({ ...lineForm }).some((value) => !value)) return setValidity(true)
      setValidity(false)
    } else {
      if (otherNoFilledValues) return setValidity(true)
      if ((values[3] && values[4] === '') || (values[3] === '' && values[4])) return setValidity(false)
      setValidity(true)
    }
  }, [values])

  const nextStep = async () => {
    present({
      message: `Comprobando datos. <br/> Esperá por favor.`
    })
    const validationsResponse = await chipAndLineValidations()
    if (validationsResponse?.portable && !validationsResponse.activated) {
      const documentResponse = await savePortabilityDocuments(validationsResponse)
      dismiss()
      if (documentResponse?.success) {
        toastMessage('Los datos se guardaron correctamante.', 3000, 'bottom', 'success')
        setNewProcedureStep(newProcedureStep + 1)
      }
    }
    dismiss()
  }
  return (
    <Button
      id="line-form-continue"
      className="submit-button btn-margin-down btn-margin-top"
      label="Continuar"
      landing={landing}
      validity={validity}
      handleSubmit={nextStep}
    />
  )
}

export default LineButton
